import { render, staticRenderFns } from "./bestellfiles.vue?vue&type=template&id=03664862&scoped=true&"
import script from "./bestellfiles.vue?vue&type=script&lang=js&"
export * from "./bestellfiles.vue?vue&type=script&lang=js&"
import style0 from "./bestellfiles.vue?vue&type=style&index=0&id=03664862&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03664862",
  null
  
)

export default component.exports